/**
 * 本文件只指定了一些通常用得到的对象的属性的示例，实际上可以抽取出来实时封装不需要照抄本文件的编写方式<br>
 * 例如在业务开发中需要打印之前封装：
 * <code><br>
 *     let data = {后端数据}
 *     let obj = {
 *         objectName: 'text-1',
 *         fontstyle: 0,
 *         objectdata: data.content,
 *         Xposition: 20,
 *         Yposition: 20,
 *         textfont: '黑体',
 *         fontsize: 12,
 *     }
 *     json.LabelObjectList.push(obj)
 * </code><br>
 * 如果有特殊字段需求请参考 [JSON打印对象属性说明.pdf]
 */

function getTextObj() {
    return {
        objectName: 'text-01',// 1
        objectdata: null,// 对象的内容
        fontstyle: 0,// 字体样式,0 正常体，1 粗体，2 斜体，3 斜粗体
        Xposition: 10,// 在标签上的位置，单位是mm
        Yposition: 10,// 在标签上的位置，单位是mm
        textfont: '黑体',// 字体名称，例如黑体、宋体...等
        fontsize: 10, // 字体大小
    }
}

/**
 * 条码的类型：常用的一维条码是Code 128 Auto，二维条码是Q RCode(2D) <br>
 * Code 128 Auto <br>
 * Code 128 A <br>
 * Code 128 B <br>
 * Code 128 C <br>
 * EAN-13 <br>
 * QR Code(2D) <br>
 * PDF 417(2D) <br>
 * Data Matrix(2D) <br>
 * Code 39 <br>
 * Code 39 Extended <br>
 * Code 93 <br>
 * EAN 128 Auto <br>
 * EAN 128 A <br>
 * EAN 128 B <br>
 * EAN 128 C <br>
 */
function getBarcodeObj() {
    return {
        ObjectName: 'barcode-01',//条码对象以“barcode”开头，如“barcode-01”，“barcode-02”...
        objectdata: null,//对象的内容
        Xposition: 10,//在标签上的位置，单位是mm
        Yposition: 10,//在标签上的位置，单位是mm
        barcodekind: "Code 128 Auto",//条码的类型：常用的一维条码是Code 128 Auto，二维条码是Q RCode(2D)
        barcodescale: 3.0,//条码缩放系数，可以小数，一般是整数，值1~99
        barcodeheight: 10,//条码的高度，单位mm
        barcodealign: 0,//条码的对齐方式，0为左对齐，1为居中对齐，2为右对齐
        textposition: 0,//文字相对于条码的方位，0为在条码下方，1为上方，2为不显示
        textfont: '黑体',//字体名称，例如黑体、宋体...等
        fontsize: 7//字体大小
    }
}

/**
 * 图形
 * 直线对象以“line”开头，如“line-01”，“line-02”...
 * 矩形对象以“rectangle”开头，如“rectangle-01”，“rectangle-02”...
 */
function getGraphicsObj() {
    return {
        objectName: 'rectangle-01',// 直线对象以“line”开头,矩形对象以“rectangle”开头
        startXposition: 1,//线条、矩形在标签上起始点的位置，单位是mm
        startYposition: 1,// 线条、矩形在标签上起始点的位置，单位是mm
        endXposition: 20,// 线条、矩形在标签上终止点的位置，单位是mm
        endYposition: 20,// 线条、矩形在标签上终止点的位置，单位是mm
        lineWidth: 0.5 // 线的宽度
    }
}

/**
 * 图片对象以“image”开头，如“image-01”，“image-02”...
 */
function getImageObj() {
    return {
        objectName: 'image-01',// 图片对象以"image"开头，如"image-01"，"image-02"...
        imagedata: null,// 图片数据，base64格式的字符串
        Xposition: 10,//在标签上的位置，单位是mm
        Yposition: 10,//在标签上的位置，单位是mm
        hscale: 0.5,//横向缩放率百分比
        vscale: 0.5,//竖向缩放率百分比
        aspectRatio: true,//图片是否保持长宽比，默认是
        imagefixedsize: false,//是否固定尺寸
        imagefixedwidth: 15,//图片固定宽度，单位是mm
        imagefixedheight: 15,//图片固定高度，单位是mm
        direction: 0//旋转方向，0是0度，1是90度，2是180度，3是270度
    }
}

/**
 * 该参数为RFID写入对象参数<br>
 * ->标签芯片是以十六进制来存储数据的!<br>
 * 写入内容通常以4的倍数bit写入，最少为8个bit，如果是 [超高频] 的2 word db的芯片则以8的倍数bit写入<br>
 */
function getRfidObj() {
    return {
        ObjectName: 'rfiduhf-01',//RFID对象以“rfiduhf”开头，如“rfiduhf-01”，“rfiduhf-02”...注意：超高频和高频的对象名称都是以“rfiduhf”开头
        objectdata: '12345678',//RFID对象的写入内容
        RFIDEncodertype: 0,//协议类型：0为UHF，1为HF 15693，2为HF 14443，3为NFC
        RFIDDatablock: 0,//写入数据区：0为EPC，1为USER，这个参数是超高频UHF的参数，如果是高频打印机请删去
        RFIDDatatype: 1,//写入数据类型：0为文本，1为16进制，2为网址链接（NDEF），3为纯文本（NDEF）
        RFIDerrortimes: 1,//错误重试次数
    }
}

export default {
    getTextObj,// 添加一个打印文字对象
    getBarcodeObj,// 添加一个打印条码对象
    getGraphicsObj,// 添加一个图形条码对象
    getImageObj,// 添加一个图片对象
    getRfidObj// 添加一个RFID对象
}


// WEBPACK FOOTER //
// ./src/components/label_objects.js